import { ACTION } from './../actions';
import store from 'store';
import { useCacheData } from '../../Shared/CacheData'
import { useSWCache } from '../../Shared/SWCache'
import { StoreKeys } from '../../project/Defines'

const defaultState = {
    isLoggedIn: store.get(StoreKeys.LoggedIn),
    popups: [],
    listStates: store.get(StoreKeys.ListStates) || {},
    userToken: store.get(StoreKeys.UserToken),
    culture:'en',// store.get(StoreKeys.Culture),
    role: store.get(StoreKeys.Role),
    roles: store.get(StoreKeys.Roles) || [],
    userData: store.get(StoreKeys.UserData),
    loaders: [],
    network: store.get(StoreKeys.Network) || null,
    networks: store.get(StoreKeys.Networks) || [],
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case ACTION.LOGIN:
            store.set(StoreKeys.ExpireTime, (new Date()).setMinutes((new Date()).getMinutes() + 1));
            store.set(StoreKeys.UserToken, action.payload.userToken);
            store.set(StoreKeys.LoggedIn, true);
            store.set(StoreKeys.UserData, action.payload.userData);
            store.set(StoreKeys.Culture, action.payload.culture || defaultState.culture);
            store.set(StoreKeys.Role, action.payload.role);
            store.set(StoreKeys.Roles, action.payload.roles);
            store.set(StoreKeys.Network, action.payload.network);
            store.set(StoreKeys.Networks, action.payload.networks);

            return {
                ...state,
                isLoggedIn: true,
                userToken: store.get(StoreKeys.UserToken),
                role: store.get(StoreKeys.Role),
                roles: store.get(StoreKeys.Roles),
                network: store.get(StoreKeys.Network),
                networks: store.get(StoreKeys.Networks),
                userData: store.get(StoreKeys.UserData)
            };

        case ACTION.LOGOUT:
            store.remove(StoreKeys.UserToken);
            store.remove(StoreKeys.Role);
            store.remove(StoreKeys.Roles);
            store.remove(StoreKeys.UserData);
            store.remove(StoreKeys.LoggedIn);
            store.remove(StoreKeys.Networks);
            store.remove(StoreKeys.Network);

            useCacheData.clearOnLogout();
            useSWCache.clearOnLogout();
            return {
                ...state,
                isLoggedIn: false,
                userToken: '',
                userName: null,
                role: null,
                roles: [],
                network: null,
                networks: []
            };

        case ACTION.REFRESH_LOGIN:
            store.set(StoreKeys.ExpireTime, (new Date()).setMinutes((new Date()).getMinutes() + 1));
            store.set(StoreKeys.UserToken, action.payload.userToken);
            store.set(StoreKeys.LoggedIn, true);
            let user = {...(store.get(StoreKeys.UserData))};
            user.accessToken = action.payload.accessToken;
            user.logoutUrl = action.payload.logoutUrl;
            store.set(StoreKeys.UserData, user);

            return {
                ...state,
                isLoggedIn: true,
                userToken: store.get(StoreKeys.UserToken),
                role: store.get(StoreKeys.Role),
                userData: store.get(StoreKeys.UserData)
            };

        case ACTION.CHANGE_ROLE:
            store.set(StoreKeys.Role, action.role);
            return {
                ...state,
                role: action.role
            };

        case ACTION.CHANGE_NETWORK:
            store.set(StoreKeys.Network, action.network);
            return {
                ...state,
                network: action.network
            };

        case ACTION.CHANGE_CULTURE:
            store.set(StoreKeys.Culture, action.data);
            return {
                ...state,
                culture: action.data
            };

        case ACTION.OPEN_POPUP: {
            const popups = [...state.popups];
            popups.push(action.data);
            return {
                ...state,
                popups
            };
        }

        case ACTION.CLOSE_POPUP:
            {
                const popups = [...state.popups];
                const index = popups.findIndex(p => p.windowKey === action.windowKey);
                if (index >= 0) {
                    popups.splice(index, 1);
                }
                return {
                    ...state,
                    popups
                };
            }

        case ACTION.UPDATE_POPUP_TITLE:
            {
                const popups = [...state.popups];
                const index = popups.findIndex(p => p.windowKey === action.windowKey);
                if (index >= 0) {
                    popups[index].title = action.title;
                }
                return {
                    ...state,
                    popups
                };
            }

        case ACTION.CLOSE_ALL_POPUPS: {
            return {
                ...state,
                popups: []
            };
        }
        case ACTION.SET_LIST_STATE: {
            const ls = {
                ...state.listStates,
                [action.payload.listName]: action.payload.state
            };
            store.set(StoreKeys.ListStates, ls);
            return {
                ...state,
                listStates: ls
            };
        }
        case ACTION.CLEAR_LIST_STATES: {
            store.remove(StoreKeys.ListStates);
            return {
                ...state,
                listStates: {}
            };
        }

        case ACTION.STORAGE_CHANGE: {
            return {
                ...state,
                isLoggedIn: store.get(StoreKeys.LoggedIn),
                listStates: store.get(StoreKeys.ListStates) || {},
                userToken: store.get(StoreKeys.UserToken),
                culture: store.get(StoreKeys.Culture),
                role: store.get(StoreKeys.Role),
                roles: store.get(StoreKeys.Roles),
                network: store.get(StoreKeys.Network),
                networks: store.get(StoreKeys.Networks),
                userName: store.get(StoreKeys.UserName)
            };
        }

        case ACTION.SET_LOADERS: {
            return {
                ...state,
                loaders: action.payload
            };
        }

        default:
            return state;
    }
}